/**
 * Number Utilities
 * @namespace NumberUtils
 */

export default class NumberUtils {
    /**
     * Checki if number has decimal point and return the number with 2 decimal point as default
     * @param {Number} number - Number to check
     * @param {Number} decimal - Number of decimal points to return
     */
    static toFixed(number, decimal = 2) {
        if (number === null || number === undefined) return 0;
        if (isNaN(number)) return 0;

        const num = parseFloat(number);

        if (num % 1 !== 0) {
            return num.toFixed(decimal);
        }

        return num;
    }

}